import createFormData from "../utilis/formDataHelper";
import httpClient from "../utilis/jwtRequest";

const OFFERTS_URL = "/offerts/";

function add(offertData) {
  const formData = createFormData(offertData);
  return httpClient.post(OFFERTS_URL, formData);
}

export const offertsService = { add };
